import classnames from 'classnames';

import mapValues from 'lodash/mapValues';

export default (schema, styles) => (
  mapValues(schema, (properties) => ({
    ...properties,
    className: classnames(styles.field, styles[`isType${properties.type}`]),
  }))
);
